import React from 'react';
export function PainPointsSection() {
  const painPoints = ['Llegás del colegio agotado/a y todavía tenés que planificar.', 'Buscás material de Geografía en internet y no encontrás nada completo ni actualizado.', 'Tenés que cubrir todos los ejes (espacio geográfico, población, economía, política, ambiente, Argentina) y no te da el tiempo.', 'Adaptás recursos de otras materias porque no hay material específico de Geografía listo para usar.', 'Sentís que improvisás más de lo que te gustaría.'];
  return <section className="py-10 sm:py-16 bg-[#0a0a0a]" data-id="element-106">
      <div className="max-w-3xl mx-auto px-4 sm:px-6" data-id="element-107">
        <h2 className="text-xl sm:text-3xl md:text-4xl font-black text-white text-center mb-6 sm:mb-10 leading-tight" data-id="element-108">
          Si sos docente de Geografía, esto te va a sonar familiar...
        </h2>

        <div className="space-y-3 sm:space-y-4 mb-10 sm:mb-14" data-id="element-109">
          {painPoints.map((point, i) => <div key={i} className="bg-[#141414] border-l-4 border-red-500 rounded-r-lg px-4 sm:px-6 py-3 sm:py-4" data-id="element-110">
              <p className="text-gray-300 text-sm sm:text-base leading-relaxed" data-id="element-111">
                {point}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-112">
          <h3 className="text-xl sm:text-3xl font-black text-[#16a34a] mb-3 sm:mb-4" data-id="element-113">
            ¿Y si pudieras resolver todo eso en una tarde?
          </h3>
          <p className="text-gray-400 text-sm sm:text-base max-w-2xl mx-auto mb-6 sm:mb-8 leading-relaxed" data-id="element-114">
            Con el{' '}
            <span className="text-white font-bold" data-id="element-115">
              Kit Completo Geografía Lista
            </span>{' '}
            tenés todo el material que necesitás para todo el año, organizado
            por ejes, listo para usar y adaptable a tu provincia.
          </p>

          <button onClick={() => {
          const el = document.getElementById('oferta');
          if (el) el.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="inline-flex items-center justify-center bg-[#16a34a] hover:bg-green-700 text-white text-sm sm:text-lg font-bold py-3 sm:py-4 px-6 sm:px-10 rounded-xl shadow-[0_4px_20px_rgba(22,163,74,0.4)] transition-all transform hover:-translate-y-1 uppercase tracking-wide" data-id="element-116">
            → QUIERO MI KIT COMPLETO AHORA
          </button>
        </div>
      </div>
    </section>;
}